import { render } from "./twitter.vue?vue&type=template&id=43d77ecc"
const script = {}
script.render = render

export default script